import React from "react";
import { ContentBlockItemWrapper, StyledChecklist } from "./_.styled";
import { Title } from "../Title/_.styled";
import ChecklistForm from "./../../components/ChecklistForm";

const ChecklistTab = ({ checklist, selectedReferences }) => {
  return (
    <section>
      <ChecklistForm />
      {checklist &&
        checklist.map((checklistItem) => (
          <ContentBlockItemWrapper
            data-testid="checklist-item"
            id={checklistItem.id}
            printHide={!selectedReferences.includes(checklistItem.id)}
          >
            <Title element="h2" color="secondary" fontFamily="secondary">
              {checklistItem.title}
            </Title>
            <StyledChecklist children={checklistItem.data} />
          </ContentBlockItemWrapper>
        ))}
    </section>
  );
};

ChecklistTab.displayName = "ChecklistTab";

export default ChecklistTab;
